var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTagIcon03(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M3.47507 12.7502L7.25007 16.5252C8.80007 18.0752 11.3167 18.0752 12.8751 16.5252L16.5334 12.8668C18.0834 11.3168 18.0834 8.80016 16.5334 7.24183L12.7501 3.47516C11.9584 2.6835 10.8667 2.2585 9.75007 2.31683L5.58341 2.51683C3.91674 2.59183 2.59174 3.91683 2.50841 5.57516L2.30841 9.74183C2.25841 10.8668 2.68341 11.9585 3.47507 12.7502Z",
    fill: "#FE3F51"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.9166 10.3166C9.24208 10.3166 10.3166 9.24208 10.3166 7.9166C10.3166 6.59112 9.24208 5.5166 7.9166 5.5166C6.59112 5.5166 5.5166 6.59112 5.5166 7.9166C5.5166 9.24208 6.59112 10.3166 7.9166 10.3166Z",
    fill: "#FE3F51"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTagIcon03);
export default __webpack_public_path__ + "static/media/tag-icon-03.bafc5e79961587e732fec239dd078e6b.svg";
export { ForwardRef as ReactComponent };